import { storage, STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

export const authTokenStorage = {
  getToken: () => storage.getItem(STORAGE_KEYS.TOKEN),
  setToken: (token: string) => storage.setItem(STORAGE_KEYS.TOKEN, token),
  removeToken: () => storage.removeItem(STORAGE_KEYS.TOKEN),
}
